import React from 'react';
import Chart from 'react-apexcharts';

const MixedChart = ({ actuals, targets, weeks, size = 500, max, colors }) => {
  const options = React.useMemo(
    () => ({
      optionsMixedChart: {
        colors,
        tooltip: {
          x: {
            show: false,
          },
          // custom: ({ series, dataPointIndex }) => {
          //   return `
          //     <div>Actual: ${series[0][dataPointIndex]}</div>
          //     <div>Target: ${series[2][dataPointIndex]}</div>
          //   `;
          // },
        },
        chart: {
          // id: 'basic-bar',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            // endingShape: 'arrow',
          },
          dataLabels: {
            enabled: false,
          },
        },
        stroke: {
          width: [4, 0, 0],
        },
        xaxis: {
          categories: weeks,
        },
        markers: {
          size: 6,
          strokeWidth: 3,
          fillOpacity: 0,
          strokeOpacity: 0,
          hover: {
            size: 8,
          },
        },
        yaxis: {
          labels: {
            show: true,
            minWidth: 50,
            maxWidth: 50,
          },
          tickAmount: 5,
          min: 0,
          max: Math.ceil(Math.max(...[...actuals, ...targets]) / max) * max,
        },
      },
      seriesMixedChart: [
        // {
        //   name: 'Actual',
        //   type: 'line',
        //   data: actuals,
        // },
        {
          name: 'Actual',
          type: 'column',
          data: actuals,
        },
        {
          name: 'Target',
          type: 'column',
          data: targets,
        },
      ],
    }),
    [weeks, targets, actuals],
  );
  return (
    <Chart
      options={options.optionsMixedChart}
      series={options.seriesMixedChart}
      type="line"
      width={size}
    />
  );
};

export default MixedChart;
